export default __webpack_public_path__ + "6a1d38e291ce3f5f366f0d33eaf3465e.svg";